import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 引入 Element Plus 样式和组件
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// 多租户：提前加载请求模块，使全局 X-Tenant-Id 默认头在首个请求前生效
import '@/utlis/request'

Vue.use(ElementUI)
Vue.config.productionTip = false

// // 处理警告信息并决定是否显示。
// Vue.config.warnHandler = function (msg, vm, trace) {
//   if (msg.includes('Avoided redundant navigation to current location')) {
//     // 忽略 'Avoided redundant navigation to current location' 警告
//     return null // 不做任何操作，抑制警告
//   }
//   // 其他警告仍然显示
//   console.warn(msg, trace)
// }

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
